import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, Typography, Checkbox, IconButton, } from "@mui/material";
import { FiUpload } from "react-icons/fi";
import { LuTrash2 } from "react-icons/lu";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";

const AddSchedule = (props) => {
    const dispatch = useDispatch();
    const { open, handleClose } = props;
    const [files, setFiles] = useState([]);

    const validationSchema = Yup.object().shape({
        files: Yup.array().min(1, "Please upload a file."),
    });

    const handleFileUpload = (event, setFieldValue) => {
        const uploadedFile = event.target.files[0];
        if (uploadedFile) {
            setFiles([uploadedFile]);
            setFieldValue("files", [uploadedFile]);
        }
    };

    const handleRemoveFile = (setFieldValue) => {
        setFiles([]);
        setFieldValue("files", []);
    };

    const handleSubmit = (values) => {
        console.log("Form submitted:", values);
        openNotification("File uploaded successfully!", 'success')
        handleClose();
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <>
            {/* ---------- Popup Dialog ---------- */}
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                        backgroundColor: "#ECECEC",
                        pb: 2,
                        pt: 3,
                        width: "100%",
                    }}
                >
                    <Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                            Add New Baseline Schedule
                        </Typography>
                        <Typography sx={{
                            pt: 2, fontWeight: 400, fontSize: "14px", lineHeight: "100%", color: "#433F5E", fontFamily: "Outfit, sans-serif",
                        }}>
                            Add a new schedule for your project
                        </Typography>
                    </Box>

                </DialogTitle>
                <Formik
                    initialValues={{ files: [], isRevised: false }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                        <Form onSubmit={handleSubmit}>
                            <DialogContent sx={{ width: "100%", p: 4, overflowX: "hidden", boxSizing: "border-box" }}>
                                {files.length === 0 && (
                                    <Box
                                        sx={{
                                            mt: 3,
                                            position: "relative",
                                            borderRadius: "3px",
                                            backgroundColor: "#ECECEC",
                                            height: 120,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            transition: "all 0.2s ease",
                                            backgroundImage: `
                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),   /* top */
                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px), /* right */
                                repeating-linear-gradient(90deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px),  /* bottom */
                                repeating-linear-gradient(180deg, rgba(113,131,155,0.7) 0 5px, transparent 5px 10px)  /* left */
                            `,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "100% 1px, 1px 100%, 100% 1px, 1px 100%",
                                            backgroundPosition: "top left, top right, bottom left, top left",
                                        }}
                                        onClick={() => document.getElementById("fileUploadInput").click()}
                                    >
                                        <input
                                            type="file"
                                            id="fileUploadInput"
                                            hidden
                                            onChange={(e) => handleFileUpload(e, setFieldValue)}
                                        />

                                        <FiUpload color="#71839B" size={42} />
                                        <Typography
                                            sx={{
                                                mt: 1,
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                lineHeight: "100%",
                                                letterSpacing: "0.14px",
                                                color: "#71839B",
                                                fontFamily: "Outfit, sans-serif",
                                            }}
                                        >
                                            Upload attachment
                                        </Typography>
                                    </Box>
                                )}

                                {files.length > 0 && (
                                    <Box

                                        sx={{
                                            display: "flex", alignItems: "center", gap: 1, mt: 2,
                                            border: "1px solid #ECECEC",
                                            borderRadius: 1,
                                            px: 2,
                                            py: 4,
                                        }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: "14px",
                                                color: "#324054",
                                                lineHeight: "22px",
                                                fontFamily: "Outfit, sans-serif",
                                            }}
                                        >
                                            File: {files[0].name}
                                        </Typography>

                                        <IconButton
                                            onClick={() => handleRemoveFile(setFieldValue)}
                                        >
                                            <LuTrash2 color="red" size={15} />
                                        </IconButton>

                                    </Box>
                                )}
                                {touched.files && errors.files && (
                                    <Typography
                                        sx={{
                                            mt: 1,
                                            color: "#F15744",
                                            fontSize: "13px",
                                            fontFamily: "Outfit, sans-serif",
                                        }}
                                    >
                                        {errors.files}
                                    </Typography>
                                )}

                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", md: "row" },
                                        gap: { xs: 2, md: 1 },
                                        width: "100%",
                                        boxSizing: "border-box",
                                        overflowX: "hidden",
                                        mt: 4,
                                    }}
                                >
                                    <Checkbox
                                        size="small"
                                        checked={values.isRevised}
                                        onChange={(e) =>
                                            setFieldValue("isRevised", e.target.checked)
                                        }
                                        sx={{
                                            color: "#726F86",
                                            '&.Mui-checked': {
                                                color: "#00344C",
                                            },
                                            p: 0,
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            flexGrow: 1,
                                            color: "#726F86",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                            mt: 1.5,
                                        }}
                                    >
                                        This is a revised schedule
                                    </Typography>
                                    <Button onClick={handleClose}
                                        sx={{
                                            textTransform: "none",
                                            color: "#F15744",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                        }}>
                                        Cancel
                                    </Button>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        sx={{
                                            backgroundColor: "#00344C",
                                            borderRadius: "25px",
                                            textTransform: "none",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            lineHeight: "100%",
                                            fontFamily: "Outfit, sans-serif",
                                            color: "#FFFFFF",
                                            px: "18px",
                                            py: "12px",
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    );
};

export default AddSchedule;